import { createContext, useReducer, useContext } from 'react';

const FiltersContext = createContext<any>(null);
const FiltersDispatchContext = createContext<any>(null);
const initialFilters = {};

export function FiltersProvider({ children }: { children: React.ReactNode }) {
  const [filters, dispatch] = useReducer(filtersReducer, initialFilters);
  return (
    <FiltersContext.Provider value={filters}>
      <FiltersDispatchContext.Provider value={dispatch}>{children}</FiltersDispatchContext.Provider>
    </FiltersContext.Provider>
  );
}

export function useFilters() {
  const context = useContext(FiltersContext);
  if (context === undefined) {
    throw new Error('useFilters() must be used within a FiltersProvider');
  }
  return context;
}

export function useFiltersDispatch() {
  const context = useContext(FiltersDispatchContext);
  if (context === undefined) {
    throw new Error('useFiltersDispatch() must be used within a FiltersProvider');
  }
  return context;
}

function filtersReducer(state: any, action: any) {
  switch (action.type) {
    case 'setFilters': {
      return { ...action.payload };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}
